const pick = (lines) => lines[Math.floor(Math.random() * lines.length)];

const WRONG_ANSWER_LINES = [
  'Wrong. Latvia is not a lake.',
  'You just sank the ship.',
  'Compass says no.',
  'That’s a fridge, not India.',
  'Wrong continent, champ.',
  'The globe hung up on you.',
  'Lost already?',
  'You’d discover the snack aisle.',
];

const RANKS = [
  {
    max: 0,
    animal: 'Snail',
    messages: [
      "Snail rank! 🐌 If you were Christopher Columbus you would sink your ship in a few hours and discover only what’s new in your fridge to feed yourself up with embarrassment.",
      "Snail rank! 🐌 Zero. You didn’t leave the harbor. Magellan would revoke your passport and hand you a coloring book of shapes that might be countries.",
      "Snail rank! 🐌 You looked at two numbers and drowned. GPS would file a missing-person report for your sense of direction.",
    ],
  },
  {
    max: 3,
    animal: 'Turtle',
    messages: [
      "Turtle mode! 🐢 One poke at the globe, then you treated Australia like a large swimming pool. Slow, lost, and proud of it.",
      "Turtle mode! 🐢 You think the equator is a suggestion. That streak died because you mixed a country up with a condiment.",
      "Turtle mode! 🐢 You’d follow a paper map into a wall. The ocean is that big blue thing, not a rumor from your fridge.",
    ],
  },
  {
    max: 7,
    animal: 'Rabbit',
    messages: [
      "Rabbit rank! 🐇 Mid geography at best. Don’t get hoppy — continents are not a group project you can skip.",
      "Rabbit rank! 🐇 A few correct guesses, then you treated Europe like a suburb and hoped nobody would notice.",
      "Rabbit rank! 🐇 Average with extra steps. You’d land in Portugal and ask where the kangaroos are.",
    ],
  },
  {
    max: 12,
    animal: 'Wolf',
    messages: [
      "Wolf rank? 🐺 Barely. A little above average isn’t a personality. The cartographers would scroll past this and not look back.",
      "Wolf rank? 🐺 The pack would leave you at the visitor center. You still think “higher” means the flag looks bigger.",
      "Wolf rank? 🐺 Not a disaster, which is the nicest thing anyone will say until you stop sinking the ship on purpose.",
    ],
  },
  {
    max: 19,
    animal: 'Cheetah',
    messages: [
      "Cheetah? 🐆 Don’t. A decent streak isn’t a geography degree. You almost had a real run, which is a fancy way of saying you still got lost.",
      "Cheetah? 🐆 Close-ish. You’d still sink the Santa María three docks from home. Come back at 20.",
      "Cheetah? 🐆 Don’t frame this. Explorers with this score get a participation globe and a lecture about Latvia not being a lake.",
    ],
  },
  {
    max: 24,
    animal: 'Falcon',
    messages: [
      "Falcon-level geography! 🦅 That’s actually impressive. You compared numbers like you own an atlas — then still walked off the map looking for a snack.",
      "Falcon-level memory of the globe! 🦅 Rare praise: you earned it. Shame the last pick thought Greenland was a grocery store.",
    ],
  },
  {
    max: Infinity,
    animal: 'Peregrine Falcon',
    messages: [
      "Peregrine Falcon! 🦅 Are you even human? Columbus wishes his “India” had this many correct turns. Then you still found a way to sink it.",
      "Peregrine Falcon! 🦅 Atlas menace. That streak was real — the last miss is the only proof you’re mortal.",
    ],
  },
];

export const pickWrongAnswerRoast = () => pick(WRONG_ANSWER_LINES);

export const getHigherOrLowerRank = (score) => {
  const n = Number(score);
  const value = Number.isFinite(n) && n > 0 ? n : 0;
  const rank = RANKS.find((entry) => value <= entry.max) || RANKS[RANKS.length - 1];
  return {
    animal: rank.animal,
    message: pick(rank.messages),
  };
};
